class ContactForm {
	constructor() {
		const modelSelect = document.querySelector("select#model-list");
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		let currentModel = params.modele;

		if (! modelSelect || ! currentModel) {
			return;
		}

		setTimeout(() => {
			modelSelect.value = currentModel;

		}, 0);

		// const options = modelSelect.querySelectorAll("option");
		// options.forEach(option => {
		// 	if (option.value === currentModel) {
		// 		console.log(option.value);
		// 		option.selected = true;
		// 	}
		// });

	}
}